// Keyed by Client.vbaShortClientName, lowercased.
const TENANT_TAGS: Record<string, {code: string; color: string}> = {
  synrgy: {code: 'SYN', color: '#0E7490'},
  quantum: {code: 'QTM', color: '#7C3AED'},
  healthcues: {code: 'HC', color: '#059669'},
};

const FALLBACK_COLOR = '#64748B';

export const tenantColor = (shortName: string) =>
  TENANT_TAGS[shortName.toLowerCase()]?.color ?? FALLBACK_COLOR;

export function TenantTag({shortName}: {shortName: string | null}) {
  if (!shortName) return null;
  const tag = TENANT_TAGS[shortName.toLowerCase()] ?? {
    code: shortName.slice(0, 3).toUpperCase(),
    color: FALLBACK_COLOR,
  };
  return (
    <span
      title={shortName}
      className='inline-flex shrink-0 items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-bold uppercase tracking-[0.04em]'
      style={{color: tag.color, backgroundColor: `${tag.color}1A`}}
    >
      <span className='h-1.5 w-1.5 rounded-full' style={{backgroundColor: tag.color}} />
      {tag.code}
    </span>
  );
}
